import React from 'react';
import DropDownMenu from '../DropDownMenu';
import EventTimezone from '../EventTimezone/EventTimezone';
import './ScreenTitle.scss';
import styles from './ScreenTitle.module.scss';

const ScreenTitle = (props) => {
    const { className = '', style: customStyle = {}, children, event, screen, menu } = props,
        classes = ['ScreenTitle', styles.ScreenTitle, className, menu ? 'hasMenu' : null],
        style = {
            ...customStyle,
        };

    return (
        <h2 className={classes.join(' ')} style={style}>
            <div className={styles.title}>
                <div
                    className={styles.screenTitle}
                    style={{
                        color: event ? event.settings.primary_color : null,
                    }}>
                    {screen}
                    {event ? <EventTimezone className={styles.timezone} event={event} /> : null}
                </div>
                {event ? <div className={styles.eventName}>{event.name}</div> : null}
            </div>
            {children}
            {menu ? <DropDownMenu options={menu} /> : null}
        </h2>
    );
};

export default ScreenTitle;
